import { Badge, Box } from "@material-ui/core";
import MailIcon from "@material-ui/icons/Mail";

const CustomStepIcon = ({ slNo }) => {
  return (
    <Box
      style={{
        width: "24px",
        height: "24px",
        backgroundColor: "#077F83",
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <p style={{ fontSize: "0.75rem", color: "#fff" }}> {slNo}</p>
    </Box>
  );
};

const StepIconComponent = ({ createdByEmail, slNo }) => {
  if (createdByEmail) {
    return (
      <Badge
        badgeContent={
          <MailIcon color="secondary" style={{ fontSize: "1rem" }} />
        }
        style={{ zIndex: 0 }}
      >
        <CustomStepIcon slNo={slNo} />
      </Badge>
    );
  } else {
    return <CustomStepIcon slNo={slNo} />;
  }
};
export default StepIconComponent;
